<template>
  <div class="bonus-program-info">
    <div v-if="loading" class="loading-wrap">
      <a-spin size="small" />
    </div>
    <template v-else>
      <div class="info-row">
        <span class="label">ProgramTitle:</span>
        <span class="value">{{ detail.title || '—' }}</span>
      </div>
      <div class="info-row">
        <span class="label">Brand:</span>
        <span class="value">{{ detail.brandName || '—' }}</span>
      </div>
      <div class="info-row">
        <span class="label">Period:</span>
        <span class="value">{{ formatPeriod(detail) }}</span>
      </div>
      <div class="bonus-rule-row">
        <span class="label">BonusRule:</span>
        <span v-if="detail.bonusRuleType === 'tier'" class="rule-link">Tier Rates</span>
       
        <span v-else class="value">fixed</span>
      </div>
      <div v-if="detail.bonusRuleType === 'fixed'">
        <span class="value">{{ detail.bonusRuleSummary }}</span>
      </div>
      <artmisads-table
        v-if="detail.bonusRuleType === 'tier' && tierRates.length"
        class="tier-table"
        :columns="tierColumns"
        :data-source="tierRates"
        :pagination="false"
        size="small"
        row-key="tierLevel"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'tierLevel'">Tier {{ record.tierLevel }}</template>
          <template v-if="column.key === 'targetSales'">
            {{ currencySymbol }} {{ formatAmount(record.targetSales) }}
          </template>
          <template v-if="column.key === 'bonusRate'">{{ record.bonusRate*100 }}%</template>
        </template>
      </artmisads-table>

      <p class="footer-note">
        All bonus commissions will be calculated on a monthly basis. Each monthly billing statement will
reflect the bonus earned in the previous calendar month.
      </p>
    </template>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { creatorConnectionsApi } from '@/server/index';
import { CURRENCY_DATA_MAPPER } from '@/contants/common';
import moment from 'moment';
const MOCK_TIER_RATES = [
  { tierLevel: 1, targetSales: 100, bonusRate: 10 },
  { tierLevel: 2, targetSales: 200, bonusRate: 20 },
  { tierLevel: 3, targetSales: 300, bonusRate: 30 },
];

const props = defineProps({
  programId: {
    type: [String, Number],
    default: null,
  },
});

const loading = ref(false);
const detail = ref({});
const tierRates = ref([]);

const currencySymbol = computed(() => CURRENCY_DATA_MAPPER[detail.value.currencyCode] || '$');

const tierColumns = [
  { title: 'TierLevel', dataIndex: 'tierLevel', key: 'tierLevel' },
  { title: 'TargetSales', dataIndex: 'targetSales', key: 'targetSales' },
  { title: 'BonusRate', dataIndex: 'bonusRate', key: 'bonusRate' },
];

const formatAmount = (val) => Number(val || 0).toFixed(2);

const formatPeriod = (row) => {
  const start = row.startDateInEpochMills ? moment(row.startDateInEpochMills).format('YYYY-MM-DD') : '';
  let end ='' 
  if(row.cancelEffectiveDateInEpochMills){
    end = row.cancelEffectiveDateInEpochMills ? moment(row.cancelEffectiveDateInEpochMills).format('YYYY-MM-DD') : '';
  }else{
    end = row.endDateInEpochMills ? moment(row.endDateInEpochMills).format('YYYY-MM-DD') : '';
  }
 
  if (!start && !end) return '—';
  return `${start} - ${end}`;
};

const fetchDetail = async () => {
  if (!props.programId) return;
  loading.value = true;
  try {
    const res = await creatorConnectionsApi.getBonusProgramDetail({ programId: props.programId });
    if (res?.success && res?.data) {
      detail.value = res.data;
      // console.log(detail.value,'数据');
      tierRates.value = detail.value.tierRates;
    } 
   
  } finally {
    loading.value = false;
  }
};

watch(
  () => props.programId,
  (id) => {
    if (id) fetchDetail();
  },
  { immediate: true }
);
</script>

<style scoped lang="less">
.bonus-program-info {
  // width: 420px;
  max-width: 90vw;
}

.loading-wrap {
  display: flex;
  justify-content: center;
  padding: 24px;
}

.info-row,
.bonus-rule-row {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 13px;
  line-height: 18px;
}

.label {
  color: rgba(15, 6, 41, 0.5);
  flex-shrink: 0;
}

.value {
  color: rgba(15, 6, 41, 0.9);
  font-weight: 500;
}

.rule-link {
  font-weight: 500;
}

.rule-fixed {
  color: rgba(15, 6, 41, 0.9);
  font-weight: 500;
}

.bonus-rule-row {
  align-items: center;
  // justify-content: space-between
}

.tier-table {
  margin: 12px 0 16px;
}

.footer-note {
  margin: 0;
  font-size: 12px;
  line-height: 16px;
  color: rgba(15, 6, 41, 0.6);
}
</style>
